var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('layout-shell');
import { breakpoints, theme } from '@shapeable/theme';
import ReactTooltip from 'react-tooltip';
import { Helmet } from 'react-helmet';
import { isFunction } from 'lodash';
import { Modal } from './modal';
import { SiteSidebar } from '../entities/site-sidebar';
import { CookieBanner } from './cookie-banner';
import { useCookieLevel } from '../hooks/use-cookie-level';
import { useReady } from '../hooks/use-ready';
import { useModal } from '../hooks/use-modal';
import { useEnv } from '../hooks/use-env';
import { usePageEntity } from '../hooks/use-page-entity';
import { useActiveEntity } from '../hooks/use-active-entity';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
export var LayoutShellDefaultProps = {
  hideOverflow: true,
  showCookieBanner: true,
  includeTooltip: false,
  includeModal: true,
  colors: {
    background: 'bright',
    text: 'strong'
  }
};
// -------- Styles -------->
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    background: ", ";\n  }\n"], ["\n  body {\n    background: ", ";\n  }\n"])), theme.COLOR('bright'));
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    min-width: 320px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    \n    ", "\n\n    ", "\n\n  "], ["\n    ", ";\n    font-family: ", ";\n    min-width: 320px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    \n    ", "\n\n    ", "\n\n  "])), theme.APPLY_COLORS, theme.FONT('sans'), function (_a) {
    var hideOverflow = _a.hideOverflow;
    return hideOverflow && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      overflow-y: hidden;\n      min-height: 100vh;\n    "], ["\n      overflow-y: hidden;\n      min-height: 100vh;\n    "])));
  }, function (_a) {
    var hideScrollbars = _a.hideScrollbars;
    return hideScrollbars && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      overflow-y: hidden;\n      height: 100vh;\n    "], ["\n      overflow-y: hidden;\n      height: 100vh;\n    "])));
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: 0;\n    ", "\n  "], ["\n    padding-right: 0;\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-right: ", "px;\n    "], ["\n      padding-right: ", "px;\n    "])), sidebarWidth);
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-right: 0;\n    ", "\n  "], ["\n    padding-right: 0;\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-right: ", "px;\n    "], ["\n      padding-right: ", "px;\n    "])), sidebarWidth);
  })
});
var TooltipStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    max-width: 220px;\n    line-height: 1.45em;\n    text-align: left;\n    padding: ", " !important;\n    border-radius: 0;\n    box-shadow: 0 1px 1px rgba(0,0,0,0.3);\n    font-family: ", ";\n    \n    &.place-top::after {\n      filter: drop-shadow(1px 1px 0px rgba(0,0,0,0.2));\n    }\n\n    &.show {\n      opacity: 1.0 !important;\n    }\n\n    p {\n      margin: 0 0 ", " 0;\n      font-size: ", ";\n      &:last-of-type {\n        margin: 0;\n      }\n    }\n\n    a {\n      color: ", ";\n      font-weight: 500;\n      text-decoration: none;\n      \n    }\n  "], ["\n    max-width: 220px;\n    line-height: 1.45em;\n    text-align: left;\n    padding: ", " !important;\n    border-radius: 0;\n    box-shadow: 0 1px 1px rgba(0,0,0,0.3);\n    font-family: ", ";\n    \n    &.place-top::after {\n      filter: drop-shadow(1px 1px 0px rgba(0,0,0,0.2));\n    }\n\n    &.show {\n      opacity: 1.0 !important;\n    }\n\n    p {\n      margin: 0 0 ", " 0;\n      font-size: ", ";\n      &:last-of-type {\n        margin: 0;\n      }\n    }\n\n    a {\n      color: ", ";\n      font-weight: 500;\n      text-decoration: none;\n      \n    }\n  "])), theme.UNIT(3), theme.FONT('sans'), theme.UNIT(4), theme.FONT_SIZE(14), theme.COLOR('link')),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    max-width: 400px;\n  "], ["\n    max-width: 400px;\n  "])))
});
var CookieBannerStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    height: 500px;\n    overflow-y: auto;\n    width: 100%;\n    z-index: 10000;\n    background: #EBEBEB;\n  "], ["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    height: 500px;\n    overflow-y: auto;\n    width: 100%;\n    z-index: 10000;\n    background: #EBEBEB;\n  "]))),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    height: auto;\n  "], ["\n    height: auto;\n  "])))
});
var ModalStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SidebarStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Modal: styled(Modal)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles),
  Sidebar: styled(SiteSidebar)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), SidebarStyles),
  CookieBanner: styled(CookieBanner)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CookieBannerStyles),
  Tooltip: styled(ReactTooltip)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles)
};
export var LayoutShell = React.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    includeTooltip = props.includeTooltip,
    id = props.id,
    includeModal = props.includeModal,
    modalColor = props.modalColor,
    modalOpacity = props.modalOpacity,
    colors = props.colors;
  var _a = __read(useCookieLevel(), 2),
    cookies = _a[0],
    setCookies = _a[1];
  var isReady = useReady().isReady;
  var modal = useModal();
  var env = useEnv();
  var pageEntity = usePageEntity();
  var activeEntity = useActiveEntity();
  var hideScrollbars = false; //map.isVisible && map.isInitialized;
  var hideOverflow = isFunction(props.hideOverflow) ? props.hideOverflow({
    pageEntity: pageEntity,
    activeEntity: activeEntity
  }) : props.hideOverflow;
  var tooltipProps = __assign({
    delayShow: 0,
    effect: "solid",
    backgroundColor: '#FFFFFF',
    clickable: true,
    type: 'light'
  }, props.tooltipProps || {});
  var sidebar = useSiteSidebar();
  // NB: This MUST now be undefined and not just falsy, as we'll use "false" to store rejection
  var showCookieBanner = true;
  if (typeof window !== undefined) {
    showCookieBanner = props.showCookieBanner && cookies === 'unknown' && isReady;
  }
  var onScroll = function () {
    ReactTooltip.hide();
  };
  return React.createElement(React.Fragment, null, env.GOOGLE_ANALYTICS_TRACKING_ID && React.createElement(Helmet, null, React.createElement("script", {
    type: "text/javascript"
  }, "\n          if (typeof window !== 'undefined') {\n            window['ga-disable-".concat(env.GOOGLE_ANALYTICS_TRACKING_ID, "'] = ").concat(cookies === 'accept' ? 'false' : 'true', ";\n          }\n          "))), includeTooltip && isReady && React.createElement(My.Tooltip, __assign({}, tooltipProps)), React.createElement(GlobalStyle, null), includeModal && modal.component && React.createElement(My.Modal, {
    color: modalColor || modal.color,
    opacity: modal.opacity || modalOpacity || 0.99
  }, modal.component), React.createElement(My.Container, {
    colors: colors,
    sidebarWidth: sidebar.isAvailable() && sidebar.width,
    hideScrollbars: hideScrollbars,
    hideOverflow: hideOverflow,
    onScroll: onScroll,
    id: id,
    ref: ref,
    className: cls.name(className)
  }, children, showCookieBanner && React.createElement(My.CookieBanner, {
    onButtonClick: function () {
      return setCookies('accept');
    },
    onRejectButtonClick: function () {
      return setCookies('reject');
    },
    onFunctionalOnlyButtonClick: function () {
      return setCookies('accept-functional');
    }
  }), sidebar.isAvailable() && React.createElement(My.Sidebar, null)));
});
LayoutShell.defaultProps = LayoutShellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;